import { render, staticRenderFns } from "./detailVAReport.vue?vue&type=template&id=c7db201c&scoped=true"
import script from "./detailVAReport.vue?vue&type=script&lang=js"
export * from "./detailVAReport.vue?vue&type=script&lang=js"
import style0 from "./detailVAReport.vue?vue&type=style&index=0&id=c7db201c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7db201c",
  null
  
)

export default component.exports